import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SuccessButton from '../../Buttons/SuccessButton/SuccessButton';
import DismissButton from '../../Buttons/DismissButton/DismissButton';
import { GREEN_SUCCESS, RED_FAILURE, WHITE } from '../../../styles/shared/colors';

class ConfirmModal extends Component {
  render() {
      const {onApprove,onDismiss,title,position} = this.props;
    const buttonStyle = {
      width: '100px',
      height: '30px',
      fontSize: '14px'
    };
    return (
      <div className="confirmModal__container" style={{position: position || 'fixed'}}>
        {title}
        <div className="confirmModal__buttons">
          <DismissButton 
            onClick={onDismiss} 
            background={RED_FAILURE}
            color={WHITE} 
            style={buttonStyle} 
            showBorder={false}          
          />
          <SuccessButton onClick={onApprove} background={GREEN_SUCCESS} style={buttonStyle} />
        </div>
      </div>
    );
  }
}

ConfirmModal.propTypes = {
  /** title to show in the confirm modal */
  title: PropTypes.string.isRequired,
  /** func to call when success button is clicked */
  onApprove: PropTypes.func,
  /** func to call when dismiss button is clicked */
  onDismiss: PropTypes.func
};

export default ConfirmModal;
